import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Users, ArrowRight } from "lucide-react";
import { Badge } from "./Primitives";

export default function UnitCard({ unit }) {
  return (
    <Link
      to={`/units/${unit.slug}`}
      className="card-bcs p-6 flex flex-col group"
      data-testid={`unit-card-${unit.slug}`}
    >
      <div className="flex items-center justify-between">
        <Badge tone="maroon">{unit.deanery} Deanery</Badge>
        {unit.is_featured && <Badge tone="gold">Featured</Badge>}
      </div>
      <h3 className="mt-4 font-serif text-xl font-semibold text-ink leading-snug group-hover:text-maroon transition-colors">
        {unit.parish_name}
      </h3>
      <p className="mt-1 text-xs text-ink-muted flex items-center gap-1.5">
        <MapPin size={13} className="text-gold-dark" /> {unit.area}, Mumbai
      </p>
      <p className="mt-3 text-sm text-ink-soft leading-relaxed line-clamp-3 flex-1">
        {unit.description}
      </p>
      <div className="mt-5 pt-4 border-t border-gray-100 flex items-center justify-between text-xs text-ink-muted">
        <span className="flex items-center gap-1.5">
          <Users size={14} className="text-gold-dark" />
          {unit.member_count ? `${unit.member_count.toLocaleString("en-IN")} members` : "BCS Unit"}
        </span>
        <span className="inline-flex items-center gap-1 font-medium text-maroon">
          View unit <ArrowRight size={13} className="transition-transform group-hover:translate-x-0.5" />
        </span>
      </div>
    </Link>
  );
}
